$(function() {
    $('.popup .wpcf7').on('wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed', function (event) {
        setTimeout(function () {
            document.querySelector('#' + event.currentTarget.id + ' .wpcf7-response-output').scrollIntoView({
                behavior: 'smooth',
            });
        }, 250);
    });
});
